export function isFunction(input) {
    return typeof input === 'function';
}
export function isFetchRequest(input) {
    return input instanceof Request;
}
export function isFetchHeaders(input) {
    return input instanceof Headers;
}
export function isNativeFetch(func) {
    if (isFunction(func)) {
        return /^function fetch\(\)[\s\S]+\[native code\].*/gi.test(func.toString());
    }
    return false;
}
export function isObject(input) {
    return Object.prototype.toString.call(input) === '[object Object]';
}
export function isString(input) {
    return typeof input === 'string' || input instanceof String;
}
export function isSymbol(input) {
    return typeof input === 'symbol';
}
export function isEmptyString(input) {
    return input.trim() === '';
}
export function isPlainObject(obj) {
    if (!isObject(obj))
        return false;
    let proto = obj;
    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
